/*
 * Psydeck mobile menu (snippets/psydeck-mobile-menu.liquid).
 * Opens/closes the drawer, slides between the main panel and item panels,
 * keeps focus inside while open, re-checks scheduled elements in the browser,
 * and fills the rewards card from the Growave SDK for logged-in customers.
 */
(function () {
  var psyMmOpenSearch = null;
  var searchHooked = false;
  // Listeners on window/document from the last setup; a Theme Editor re-render
  // removes them before setting up the new markup.
  var globalListeners = null;
  // Search page settings, kept in line with snippets/psydeck-search-page.liquid.
  var SEARCH_PARAMS = '&type=product&options%5Bprefix%5D=last' +
    '&options%5Bfields%5D=title,product_type,variants.title,variants.sku,vendor,tag' +
    '&options%5Bunavailable_products%5D=last';

  // This menu serves the header below 750px, and at any width on touch screens,
  // where Horizon switches the header to its drawer layout (data-menu-style).
  function usesDrawerHeader() {
    var h = document.getElementById('header-component');
    return window.matchMedia('(max-width: 749px)').matches || (h && h.dataset.menuStyle === 'drawer');
  }

  function init() {
    var root = document.querySelector('[data-psy-mm]');
    if (!root || root.dataset.psyMmReady) return;
    root.dataset.psyMmReady = '1';
    if (globalListeners) globalListeners.abort();
    globalListeners = window.AbortController ? new AbortController() : null;
    var on = globalListeners ? { signal: globalListeners.signal } : false;

    var drawer = root.querySelector('[data-psy-mm-drawer]');
    var toggle = root.querySelector('[data-psy-mm-open]');
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-psy-mm-panel]'));
    var main = root.querySelector('[data-psy-mm-panel="main"]');
    var lastFocus = null;
    var FOCUSABLE = 'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])';

    // The drawer lives inside the sticky header; move it to <body> so fixed
    // positioning and stacking are not affected by the header's containment.
    var stale = document.body.querySelector(':scope > #' + drawer.id);
    if (stale && stale !== drawer) stale.remove();
    document.body.appendChild(drawer);

    // From 750px up (tablets) the drawer is a side panel; this dims the page next
    // to it, and a tap on it closes the menu.
    var staleScrim = document.body.querySelector(':scope > .psy-mm__scrim');
    if (staleScrim) staleScrim.remove();
    var scrim = document.createElement('div');
    scrim.className = 'psy-mm__scrim';
    scrim.hidden = true;
    document.body.insertBefore(scrim, drawer);
    scrim.addEventListener('click', function () { close(); });

    // The site header stays visible while the menu is open: the drawer sits
    // below it and the header's menu button turns into the close button.
    var header = document.getElementById('header-component');
    var headerBottom = 0;
    function measureHeader() {
      headerBottom = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
      drawer.classList.toggle('is-under-header', headerBottom > 0);
      drawer.style.setProperty('--psy-mm-top', headerBottom + 'px');
      scrim.style.setProperty('--psy-mm-top', headerBottom + 'px');
      drawer.style.top = headerBottom + 'px';
    }

    var input = drawer.querySelector('[data-psy-mm-q]');
    var sForm = drawer.querySelector('[data-psy-mm-sform]');
    var sEmpty = drawer.querySelector('[data-psy-mm-sempty]');
    var sResults = drawer.querySelector('[data-psy-mm-sresults]');
    var sAll = drawer.querySelector('[data-psy-mm-sall]');
    var sClear = drawer.querySelector('[data-psy-mm-clear]');

    function applySchedule(scope) {
      var now = Date.now() / 1000;
      (scope || drawer).querySelectorAll('[data-psy-from], [data-psy-until]').forEach(function (el) {
        var from = Number(el.dataset.psyFrom || 0);
        var until = Number(el.dataset.psyUntil || 0);
        el.hidden = (from && now < from) || (until && now >= until);
      });
    }

    // The row that opened the current submenu, focused again on the way back.
    var opener = null;

    // Each item panel's destaque and product cards ship inside <template> tags,
    // so they aren't part of the page until the panel is first opened (set and
    // tile links stay in the page for search engines). Builds them once.
    function hydrate(panel) {
      var tpls = panel ? panel.querySelectorAll('template[data-psy-lazy]') : [];
      if (!tpls.length) return;
      tpls.forEach(function (tpl) { tpl.replaceWith(tpl.content); });
      applySchedule(panel);
    }

    function showPanel(name, noFocus) {
      hydrate(drawer.querySelector('[data-psy-mm-panel="' + name + '"]'));
      drawer.classList.toggle('is-searching', name === 'search');
      panels.forEach(function (p) {
        var active = p.dataset.psyMmPanel === name;
        if (active && p.hidden) {
          p.hidden = false;
          void p.offsetWidth; // start the slide from off-screen, not from display: none
        }
        p.classList.toggle('is-active', active);
        if (!active && p.dataset.psyMmPanel !== 'main') {
          setTimeout(function () { if (!p.classList.contains('is-active')) p.hidden = true; }, 400);
        }
      });
      var panel = drawer.querySelector('[data-psy-mm-panel="' + name + '"]');
      if (!panel) return;
      if (name !== 'main') panel.scrollTop = 0;
      if (noFocus) return;
      // Focus moves into the menu so screen readers and keyboards follow it. Only
      // the search panel focuses an input (elsewhere that would pop the iOS keyboard).
      var first = name === 'search' ? input
        : name === 'main' ? (opener && opener.offsetParent !== null ? opener : panel.querySelector('a[href], button'))
        : panel.querySelector('[data-psy-mm-back]');
      if (name === 'main') opener = null;
      if (first) first.focus({ preventScroll: true });
    }

    // iOS Safari: when the keyboard opens it scrolls the visual viewport, pushing a
    // position: fixed drawer up. Pin the drawer's top to the visual viewport and pad
    // the panels by the height the keyboard covers, so content runs under Safari's
    // see-through bars and can still be scrolled into view above the keyboard.
    var vv = window.visualViewport;
    function fitViewport() {
      if (!vv || drawer.hidden) return;
      drawer.style.top = Math.max(headerBottom, vv.offsetTop) + 'px';
      // How much of the drawer sits below the visible area (the keyboard), measured
      // directly: iOS doesn't keep innerHeight consistent while the keyboard is up.
      var kb = Math.max(0, Math.round(drawer.getBoundingClientRect().bottom - vv.offsetTop - vv.height));
      drawer.style.setProperty('--psy-kb', kb + 'px');
    }
    if (vv) {
      vv.addEventListener('resize', fitViewport, on);
      vv.addEventListener('scroll', fitViewport, on);
    }

    // Scroll lock: overflow on <html> only, so the page and the sticky header stay
    // exactly where they are (a position: fixed body would move the header off
    // screen). iOS can still nudge the page when the keyboard opens, so the scroll
    // position is put back on close, instantly (the theme sets smooth scrolling).
    var savedY = 0;
    function unlockScroll() {
      var html = document.documentElement.style;
      html.overflow = '';
      if (Math.abs(window.scrollY - savedY) > 1) {
        html.scrollBehavior = 'auto';
        window.scrollTo(0, savedY);
        html.scrollBehavior = '';
      }
    }

    // True from open() until the drawer's slide-in starts (two frames later).
    var opening = false;
    // True between a tap on the menu button and open() running (see openAfterPaint).
    var pendingOpen = false;
    function isOpen() { return pendingOpen || opening || drawer.classList.contains('is-open'); }

    // Opening is split over frames so the tap gets a quick next paint (INP): the
    // tap itself only reads what it needs first (scroll position, header), then
    // shows the drawer in its closed position. The slide-in, focus and the rest
    // start in the frames after. Reading layout after writing styles in the same
    // handler made the browser recompute the whole page's styles twice per tap.
    function open() {
      if (isOpen()) return;
      opening = true;
      lastFocus = document.activeElement;
      savedY = window.scrollY;
      measureHeader();
      drawer.hidden = false;
      scrim.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', root.dataset.locale === 'pt-PT' ? 'Fechar menu' : 'Close menu');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (!opening) return;
          opening = false;
          applySchedule();
          fitViewport();
          drawer.classList.add('is-open');
          scrim.classList.add('is-open');
          // The header's search icon opens the search panel straight away (inside
          // the tap, for the iOS keyboard); otherwise start on the main panel.
          if (!activeSub()) {
            main.scrollTop = 0;
            showPanel('main');
          }
          setTimeout(function () {
            drawer.querySelectorAll('[data-psy-mm-panel="main"] img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
            loadRewards();
          }, 0);
        });
      });
    }

    // The menu button: the tap only turns the icon into the close icon, and open()
    // runs after that has been painted. Showing the drawer and locking the page's
    // scroll restyle and lay out the whole page; inside the tap that work held its
    // next paint back (real phones: 100-200 ms of rendering per tap in GA4's
    // slow_tap). The drawer still appears a frame later, too soon to notice.
    function openAfterPaint() {
      if (isOpen()) return;
      pendingOpen = true;
      toggle.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(function () {
        setTimeout(function () {
          if (!pendingOpen) return;
          pendingOpen = false;
          open();
        }, 0);
      });
    }

    function close(keepFocus, leavingPage) {
      if (!isOpen()) return;
      // Tapped again before the drawer was shown: nothing else has changed yet.
      if (pendingOpen) {
        pendingOpen = false;
        toggle.setAttribute('aria-expanded', 'false');
        return;
      }
      opening = false;
      // A header link is already navigating: going back now would race it, so
      // just mark the menu's history entry as spent.
      if (leavingPage) { if (ownsHistory()) history.replaceState(null, ''); }
      else dropHistory();
      drawer.classList.remove('is-open');
      scrim.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', root.dataset.locale === 'pt-PT' ? 'Abrir menu' : 'Open menu');
      if (input) input.blur();
      unlockScroll();
      setTimeout(function () {
        if (isOpen()) return;
        drawer.hidden = true;
        scrim.hidden = true;
        drawer.style.top = '';
        drawer.style.removeProperty('--psy-kb');
        opener = null;
        showPanel('main', true);
      }, 400);
      if (!keepFocus && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    toggle.addEventListener('click', function () { if (isOpen()) close(); else openAfterPaint(); });

    // Any other header control (logo, account, cart) closes the menu first. A
    // header link opened from a submenu or the search takes the menu's history
    // entry off first (like the menu's own links), so Back from the next page
    // needs one press.
    if (header) {
      header.addEventListener('click', function (e) {
        if (!isOpen() || toggle.contains(e.target) || (e.target.closest && e.target.closest('.search-action'))) return;
        var link = e.target.closest && e.target.closest('a[href]');
        if (link && ownsHistory() && isPlainClick(e, link)) {
          e.preventDefault();
          leaveTo(link.href);
          return;
        }
        close(true, !!link);
      });
    }

    // The header's search icon (Horizon's search-button) opens this menu's search
    // on mobile instead of the theme's search dialog. Capture phase on window, so it
    // runs before the theme's on:click handler (a capture listener on document)
    // and stops it; otherwise both the old dialog and this menu open. The input
    // is focused inside the tap so iOS shows the keyboard.
    // Registered once; a Theme Editor re-render only swaps the function it calls.
    // A menu-button tap may still be waiting to open: open now, inside this tap.
    psyMmOpenSearch = function () { pendingOpen = false; open(); openSub('search'); };
    if (!searchHooked) {
      searchHooked = true;
      window.addEventListener('click', function (e) {
        if (!usesDrawerHeader() || !psyMmOpenSearch) return;
        var btn = e.target.closest && e.target.closest('#header-component .search-action button');
        if (!btn) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        psyMmOpenSearch();
      }, true);
    }

    drawer.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-psy-mm-close]')) return close();
      var term = t.closest('[data-psy-mm-term]');
      if (term) { e.preventDefault(); input.value = term.dataset.psyMmTerm; input.blur(); return runSearch(true); }
      if (t.closest('[data-psy-mm-clear]')) { input.value = ''; input.focus(); return runSearch(); }
      if (t.closest('[data-psy-mm-back]')) return back();
      var go = t.closest('[data-psy-mm-go]');
      if (go) { e.preventDefault(); return openSub(go.dataset.psyMmGo, go); }
      var link = t.closest('a[href]');
      if (!link || !isPlainClick(e, link)) return;
      // A page is loading: a bar runs along the top of the menu and the tapped item dims.
      drawer.querySelectorAll('.is-pending').forEach(function (el) { el.classList.remove('is-pending'); });
      link.classList.add('is-pending');
      drawer.classList.remove('is-loading');
      void drawer.offsetWidth;
      drawer.classList.add('is-loading');
      // A link out of a submenu: take the menu's history entry off first, so the
      // browser's back from the next page doesn't land on it.
      if (ownsHistory()) {
        e.preventDefault();
        leaveTo(link.href);
      }
    });

    function isPlainClick(e, link) {
      return link.getAttribute('href').charAt(0) !== '#' && link.target !== '_blank' &&
        !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey && !e.defaultPrevented;
    }
    // Step back off the menu's history entry, then open the page.
    function leaveTo(href) {
      pendingHref = href;
      history.back();
      setTimeout(function () { if (pendingHref) { var h = pendingHref; pendingHref = null; location.assign(h); } }, 500);
    }

    // Back in the menu. Opening a submenu adds a history entry, so the browser's
    // back, and iOS Safari's edge swipe (which a page can't intercept), step back
    // to the main menu instead of leaving the page.
    var pendingHref = null;
    var silentPop = false;
    function ownsHistory() { return !!(history.state && history.state.psyMm); }
    function dropHistory() {
      if (!ownsHistory()) return;
      silentPop = true;
      history.back();
    }
    function activeSub() {
      var a = drawer.querySelector('.psy-mm__panel.is-active');
      return a && a.dataset.psyMmPanel !== 'main' ? a : null;
    }
    function openSub(name, from) {
      opener = from || (drawer.contains(document.activeElement) ? document.activeElement : null);
      showPanel(name);
      if (!ownsHistory()) history.pushState({ psyMm: 1 }, '');
    }
    function back() {
      showPanel('main');
      dropHistory();
    }
    // Coming back to this page from the browser's cache: clear the loading state
    // and close the menu, so the page shows as it was before the menu opened.
    window.addEventListener('pageshow', function (e) {
      pendingHref = null;
      drawer.classList.remove('is-loading');
      drawer.querySelectorAll('.is-pending').forEach(function (el) { el.classList.remove('is-pending'); });
      if (e.persisted && isOpen()) close(true, true);
    }, on);
    window.addEventListener('popstate', function () {
      if (pendingHref) { var h = pendingHref; pendingHref = null; location.assign(h); return; }
      if (silentPop) { silentPop = false; return; }
      if (isOpen() && activeSub()) showPanel('main');
    }, on);

    // Swipe right in a submenu to go back: the submenu follows the finger and the
    // main menu slides in behind it, like the iOS back gesture.
    var mainPanel = main;
    var swipe = null;
    function swipeStyle(sub, x) {
      var w = sub.offsetWidth || 1;
      sub.style.transform = x == null ? '' : 'translateX(' + x + 'px)';
      mainPanel.style.transform = x == null ? '' : 'translateX(' + (-25 * (1 - x / w)) + '%)';
      mainPanel.style.opacity = x == null ? '' : String(0.4 + 0.6 * x / w);
    }
    drawer.addEventListener('touchstart', function (e) {
      var sub = activeSub();
      swipe = null;
      if (!sub || !mainPanel || e.touches.length > 1) return;
      // Rows that scroll sideways keep their own swipe.
      if (e.target.closest('.psy-mm__sets, .psy-mm__tiles, .psy-mm__chips, input')) return;
      var t = e.touches[0];
      swipe = { sub: sub, x0: t.clientX, y0: t.clientY, t0: Date.now(), on: null, x: 0 };
    }, { passive: true });
    drawer.addEventListener('touchmove', function (e) {
      if (!swipe) return;
      var t = e.touches[0];
      var dx = t.clientX - swipe.x0, dy = t.clientY - swipe.y0;
      if (swipe.on === null) {
        if (Math.abs(dx) < 10 && Math.abs(dy) < 10) return;
        swipe.on = dx > 0 && Math.abs(dx) > Math.abs(dy) * 1.2;
        if (!swipe.on) { swipe = null; return; }
        swipe.sub.style.transition = mainPanel.style.transition = 'none';
      }
      swipe.x = Math.max(0, dx);
      swipeStyle(swipe.sub, swipe.x);
    }, { passive: true });
    function endSwipe() {
      if (!swipe || !swipe.on) { swipe = null; return; }
      var s = swipe;
      swipe = null;
      var fast = s.x > 40 && s.x / Math.max(1, Date.now() - s.t0) > 0.5;
      s.sub.style.transition = mainPanel.style.transition = '';
      void s.sub.offsetWidth;
      swipeStyle(s.sub, null);
      if (fast || s.x > s.sub.offsetWidth * 0.3) back();
    }
    drawer.addEventListener('touchend', endSwipe);
    drawer.addEventListener('touchcancel', endSwipe);

    // Start loading a panel's images on touch, before the slide, so they don't pop in.
    drawer.addEventListener('pointerdown', function (e) {
      var go = e.target.closest('[data-psy-mm-go]');
      if (!go) return;
      var panel = drawer.querySelector('[data-psy-mm-panel="' + go.dataset.psyMmGo + '"]');
      if (!panel) return;
      // Build the panel now (first open) so its images start before the click.
      hydrate(panel);
      panel.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
    });

    // Keyboard, while the menu is open: Escape steps back or closes, and Tab
    // cycles through the header's menu button (the close button) and the menu.
    document.addEventListener('keydown', function (e) {
      if (!isOpen()) return;
      if (e.key === 'Escape') {
        if (activeSub()) return back();
        close();
        return toggle.focus();
      }
      if (e.key !== 'Tab') return;
      var items = Array.prototype.filter.call(drawer.querySelectorAll(FOCUSABLE), function (el) {
        return el.offsetParent !== null && !el.closest('[hidden]');
      });
      if (toggle.offsetParent !== null) items.unshift(toggle);
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      var inside = items.indexOf(document.activeElement) !== -1;
      if (!inside) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
      else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }, on);

    // Search: live results from /search/suggest.json. Matching collections (sets,
    // product types) come first, then compact product rows; sold-out products last.
    var isPt = root.dataset.locale === 'pt-PT';
    var intl = new Intl.NumberFormat(isPt ? 'pt-PT' : 'en', { style: 'currency', currency: root.dataset.currency || 'EUR' });
    var moneyFormat = root.dataset.moneyFormat;
    var maxCollections = parseInt(root.dataset.maxCollections, 10);
    if (isNaN(maxCollections)) maxCollections = 2;
    var searchTimer = null;
    var searchCtrl = null;

    function esc(str) {
      return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    // Shopify's money format (shop.money_format, e.g. "€{{amount_with_comma_separator}}"),
    // so prices match the ones Liquid prints. Falls back to Intl when it is missing.
    function formatMoney(amount, format, fallback) {
      if (!format) return fallback.format(amount);
      var cents = Math.round(Number(amount) * 100);
      function delimit(n, decimals, thousands, decimal) {
        var parts = (n / 100).toFixed(decimals).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
      }
      var out = format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
        switch (key) {
          case 'amount_no_decimals': return delimit(cents, 0, ',', '.');
          case 'amount_with_comma_separator': return delimit(cents, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return delimit(cents, 0, '.', ',');
          case 'amount_with_apostrophe_separator': return delimit(cents, 2, "'", '.');
          case 'amount_no_decimals_with_space_separator': return delimit(cents, 0, ' ', ',');
          case 'amount_with_space_separator': return delimit(cents, 2, ' ', ',');
          case 'amount_with_period_and_space_separator': return delimit(cents, 2, ' ', '.');
          default: return delimit(cents, 2, ',', '.');
        }
      });
      return out.replace(/<[^>]*>/g, '');
    }

    function thumb(url, width) {
      if (!url) return '';
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
    }

    function render(q, res) {
      var products = (res && res.products) || [];
      var collections = (res && res.collections) || [];
      var html = '';
      if (collections.length && maxCollections > 0) {
        html += '<div class="psy-mm__kicker">' + (isPt ? 'Coleções' : 'Collections') + '</div><div class="psy-mm__scols">';
        collections.slice(0, maxCollections).forEach(function (c) {
          var img = c.featured_image && c.featured_image.url;
          html += '<a class="psy-mm__scol" href="' + esc(c.url) + '">' +
            '<span class="psy-mm__scol-img">' + (img ? '<img src="' + esc(thumb(img, 160)) + '" alt="" loading="lazy">' : '') + '</span>' +
            '<span class="psy-mm__scol-title">' + esc(c.title) + '</span>' +
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#5F8AB5" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg></a>';
        });
        html += '</div>';
      }
      if (products.length) {
        html += '<div class="psy-mm__kicker">' + (isPt ? 'Produtos' : 'Products') + '</div><ul class="psy-mm__sprods">';
        products.forEach(function (p) {
          var img = p.featured_image && p.featured_image.url || p.image;
          var price = Number(p.price);
          var badge = p.available === false ? '<span class="psy-mm__sbadge psy-mm__sbadge--out">' + (isPt ? 'Esgotado' : 'Sold out') + '</span>' : '';
          html += '<li><a class="psy-mm__sprod" href="' + esc(p.url) + '">' +
            '<span class="psy-mm__sprod-img">' + (img ? '<img src="' + esc(thumb(img, 144)) + '" alt="" loading="lazy">' : '') + '</span>' +
            '<span class="psy-mm__sprod-body"><span class="psy-mm__sprod-title">' + esc(p.title) + '</span>' +
            '<span class="psy-mm__sprod-meta">' + (isNaN(price) ? '' : '<span class="psy-mm__sprod-price">' + formatMoney(price, moneyFormat, intl) + '</span>') + badge + '</span></span></a></li>';
        });
        html += '</ul>';
      }
      if (!html) {
        html = '<p class="psy-mm__snone">' + (isPt ? 'Sem resultados para' : 'No results for') + ' “' + esc(q) + '”.</p>';
      }
      sResults.innerHTML = html;
      sResults.hidden = false;
      // No results: keep the popular searches and latest sets below the message.
      sEmpty.hidden = html.indexOf('psy-mm__snone') === -1;
      sAll.hidden = !products.length;
      sAll.href = sForm.action + '?q=' + encodeURIComponent(q) + SEARCH_PARAMS;
    }

    function runSearch(now) {
      var q = input.value.trim();
      sClear.hidden = !input.value;
      clearTimeout(searchTimer);
      if (searchCtrl) searchCtrl.abort();
      if (!q) {
        sResults.hidden = true;
        sResults.innerHTML = '';
        sEmpty.hidden = false;
        sAll.hidden = true;
        return;
      }
      searchTimer = setTimeout(function () {
        searchCtrl = window.AbortController ? new AbortController() : null;
        var params = 'q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection&resources[limit]=10&resources[limit_scope]=each' +
          '&resources[options][prefix]=last&resources[options][unavailable_products]=last' +
          '&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag';
        fetch((root.dataset.root || '/').replace(/\/$/, '') + '/search/suggest.json?' + params, searchCtrl ? { signal: searchCtrl.signal } : {})
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            if (input.value.trim() !== q) return;
            render(q, data && data.resources && data.resources.results);
          })
          .catch(function () {});
      }, now === true ? 0 : 180);
    }

    if (input) {
      input.addEventListener('input', runSearch);
      // Enter closes the keyboard and shows the results; "Ver todos" opens the search page.
      sForm.addEventListener('submit', function (e) {
        e.preventDefault();
        input.blur();
        if (input.value.trim()) runSearch(true);
      });
      // Re-measure once the keyboard has gone.
      input.addEventListener('blur', function () { setTimeout(fitViewport, 350); });
    }

    // Close if the header switches to its desktop layout while open; otherwise
    // (a phone rotating) keep the drawer under the header's new height.
    window.addEventListener('resize', function () {
      if (!isOpen()) return;
      if (!usesDrawerHeader()) return close();
      measureHeader();
      fitViewport();
    }, on);

    // Rewards card: points and tier from Growave (same SDK calls as the Clube Psydeck page).
    var rewardsLoaded = false;
    function loadRewards() {
      if (rewardsLoaded || root.dataset.loggedIn !== '1') return;
      var pointsEl = drawer.querySelector('[data-psy-mm-points]');
      var tierEl = drawer.querySelector('[data-psy-mm-tier]');
      if (!pointsEl && !tierEl) return;
      rewardsLoaded = true;
      var locale = root.dataset.locale;
      var nf = new Intl.NumberFormat(locale === 'pt-PT' ? 'pt-PT' : 'en');

      // Getters resolve to { status: 'success', result } or { status: 'error' }, and must be called on the methods object.
      function call(M, name, args) {
        if (typeof M[name] !== 'function') return Promise.resolve(null);
        try {
          return Promise.resolve(M[name].apply(M, args))
            .then(function (r) { return r && r.status === 'success' ? r.result : null; })
            .catch(function () { return null; });
        } catch (e) { return Promise.resolve(null); }
      }

      function run() {
        var M = window.gw && window.gw.sdk && window.gw.sdk.rewards && window.gw.sdk.rewards.methods;
        if (!M) return;
        Promise.all([call(M, 'getRewardsProgramAccount', [locale]), call(M, 'getRewardsVipTiers', [locale])]).then(function (res) {
          var acc = res[0], tiers = res[1] || [];
          if (acc && acc.points && acc.points.balance != null && pointsEl) {
            pointsEl.textContent = nf.format(Number(acc.points.balance)) + (locale === 'pt-PT' ? ' pontos' : ' points');
            pointsEl.hidden = false;
          }
          if (acc && acc.tier && tierEl) {
            var title = acc.tier.title;
            tiers.forEach(function (t) { if (t.id === acc.tier.id && t.title) title = t.title; });
            if (title) { tierEl.textContent = title; tierEl.hidden = false; }
          }
        });
      }
      if (window.gw && window.gw.sdk) run(); else document.addEventListener('gwSdkReady', run, { once: true });
    }
  }

  init();
  // Theme Editor: the header section re-renders with fresh markup; set it up again.
  document.addEventListener('shopify:section:load', init);
})();
